<script>
import { apiSecond } from '@/boot/axios'

import HeaderBack from '@/components/UI/HeaderBack.vue'
import ReportManageErrorModal from '@/components/reporting-management/ReportManageErrorModal.vue'
import LoadingIndicator from '@/components/UI/atoms/LoadingIndicator.vue'
import FormGroupWrapper1 from '@/components/UI/FormGroupWrappers/FormGroupWrapper1.vue'

export default {
	name: 'ReportTirView2',
	components: {
		HeaderBack,
		ReportManageErrorModal,
		LoadingIndicator,
		FormGroupWrapper1,
	},
	head: {
		title() {
			return {
				inner: this.$t('sidebar.references'),
			}
		},
		meta: [],
	},
	data() {
		return {
			pageId: 2,
			pageType: 'tir',
			reportData: null,
			loading: true,
			errorMessage: {
				status: null,
				messages: null,
				text: null,
			},
			message: {
				status: null,
				text: null,
			},
		}
	},
	computed: {
		getReportTitle() {
			return this.$t('titles.reporteds_2')
		},
	},
	methods: {
		checkError(error) {
			if (error?.response?.status > 500) {
				this.errorMessage.status = 500
				this.errorMessage.text = this.$t('system_message.500')
			} else if (error?.response?.status == 401) {
				this.errorMessage.status = 401
				this.errorMessage.text = error?.response?.data?.message
				this.$router.push('/' + this.$i18n.locale + '/login')
			} else {
				this.errorMessage.status = 422
				this.errorMessage.text = error?.response?.data?.message
			}
			this.$modal.show('ReportManageErrorModal')
		},
		async fetchReportData() {
			try {
				this.loading = true
				const response = await apiSecond.get(
					`v1/subject/show/${this.pageId}/${this.$route.params.id}`,
				)
				if (response.data) {
					this.reportData = response.data.data
				}
			} catch (error) {
				this.checkError(error)
			} finally {
				this.loading = false
			}
		},
	},
	beforeCreate() {
		if (!localStorage.token) this.$router.push('/ru/login')
	},
	async mounted() {
		await this.fetchReportData()
	},
}
</script>

<template>
	<div class="wrap__content">
		<div class="container">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['ReportingManagement']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<HeaderBack :title="getReportTitle" :subtitle="$t('reporting.reports.2-tir-rh')" />

							<div class="card__content--body">
								<LoadingIndicator v-if="loading" :text="$t('loading')" />

								<div v-else-if="reportData" class="report-details">
									<!-- Report Name -->
									<FormGroupWrapper1 :title="$t('headers.report_name')">
										<div class="form-display-value">{{ reportData.name || '-' }}</div>
									</FormGroupWrapper1>

									<!-- Send Period -->
									<FormGroupWrapper1 :title="$t('headers.send_period')">
										<div class="form-display-value">{{ reportData.surrender_date || '-' }}</div>
									</FormGroupWrapper1>

									<!-- Status -->
									<FormGroupWrapper1 :title="$t('headers.status')">
										<div class="form-display-value">{{ reportData.status || '-' }}</div>
									</FormGroupWrapper1>

									<!-- Pond/Farm -->
									<FormGroupWrapper1 :title="$t('headers.pond')">
										<div class="form-display-value">{{ reportData.farm_name || '-' }}</div>
									</FormGroupWrapper1>

									<!-- Region -->
									<FormGroupWrapper1 :title="$t('headers.region')">
										<div class="form-display-value">{{ reportData.region_name || '-' }}</div>
									</FormGroupWrapper1>

									<!-- District -->
									<FormGroupWrapper1 :title="$t('handbooks.Район')">
										<div class="form-display-value">{{ reportData.district_name || '-' }}</div>
									</FormGroupWrapper1>

									<!-- Plot -->
									<FormGroupWrapper1 :title="$t('reporting.fields.2-rh.plot')">
										<div class="form-display-value">{{ reportData.plot_name || '-' }}</div>
									</FormGroupWrapper1>

									<!-- Count of Gamekeeper Start of Year -->
									<FormGroupWrapper1
										:title="$t('reporting.fields.2-rh.count_of_gamekeeper_start_of_year')"
									>
										<div class="form-display-value">
											{{ reportData.count_of_gamekeeper_start_of_year || '-' }}
										</div>
									</FormGroupWrapper1>

									<!-- Count of Gamekeeper Start of Reporting Period -->
									<FormGroupWrapper1
										:title="
											$t('reporting.fields.2-rh.count_of_gamekeeper_start_of_reporting_period')
										"
									>
										<div class="form-display-value">
											{{ reportData.count_of_gamekeeper_start_of_reporting_period || '-' }}
										</div>
									</FormGroupWrapper1>

									<!-- Count of Protocols -->
									<FormGroupWrapper1 :title="$t('reporting.fields.2-rh.count_of_protocols')">
										<div class="form-display-value">{{ reportData.count_of_protocols || '-' }}</div>
									</FormGroupWrapper1>

									<!-- Action buttons removed - TIR users can only view -->
								</div>

								<div v-else class="no-data">
									<p>{{ $t('system_message.no_data') }}</p>
								</div>

								<ReportManageErrorModal :message="message" :errorMessage="errorMessage" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.report-details {
	padding: 20px 0;
}

.form-display-value {
	padding: 10px 20px;
	border: 1px solid #157fee;
	border-radius: 5px;
	background-color: #ffffff;
	color: #0a091d;
	font-size: 14px;
	font-weight: 400;
	min-height: 44px;
	display: flex;
	align-items: center;
	width: 100%;
	line-height: 1.2;
}

/* Ensure FormGroupWrapper1 titles match the source page styling */
:deep(.reporting__title) {
	font-weight: 600;
	font-size: 12px;
	color: #0a091d;
	margin-bottom: 8px;
	line-height: 1.2;
}

.no-data {
	text-align: center;
	padding: 40px;
	color: #666;
}
</style>
